/**
 * Metka ceny oprogramowania — abonament platformy i moduły (naprawa kasy 02.10.2026).
 *
 * Cennik (`plan_prices`, `module_prices`) jest NETTO, a od 02.10.2026 Stripe
 * pobiera BRUTTO z VAT-em 23 % w środku (`services/kasa/cenaStripe.ts`
 * w neurosense-core). Do tej zmiany ekran pokazywał gołą liczbę „349 PLN/mies.",
 * a Checkout pobierał dokładnie 349 zł — czyli netto jako brutto. Teraz
 * Checkout pokaże 429,27 zł, więc metka musi powiedzieć to samo: kwota główna
 * NETTO z dopiskiem, brutto linijkę niżej. Wzór: metka sprzętu
 * (`marketplaceDevices.ts` → `etykietaCeny`).
 *
 * Stawka jest stałą, a nie kolumną wiersza (jak przy sprzęcie), bo cała
 * sprzedaż oprogramowania idzie dziś jedną stawką — ta sama stała stoi po
 * stronie usługi (`STAWKA_VAT_OPROGRAMOWANIA`) i tylko z nią liczy się cena
 * w Stripe.
 */

import { bruttoZNetto } from './marketplaceDevices';

export const STAWKA_VAT_OPROGRAMOWANIA = 23;

export type OkresCeny = 'mies.' | 'rok';

/** „zł" dla PLN, kod waluty dla pozostałych. */
export function symbolWaluty(waluta: string | null | undefined): string {
  const kod = (waluta || 'PLN').toUpperCase();
  return kod === 'PLN' ? 'zł' : kod;
}

function kwotaPoPolsku(kwota: number): string {
  return kwota.toLocaleString('pl-PL', { maximumFractionDigits: 2 });
}

/** Dopisek przy kwocie netto: „zł netto/mies.", „zł netto/rok", „zł netto". */
export function sufiksNetto(waluta: string | null | undefined, okres?: OkresCeny): string {
  return `${symbolWaluty(waluta)} netto${okres ? `/${okres}` : ''}`;
}

/** Druga linijka metki: „429,27 zł brutto/mies."; `null`, gdy netto nie jest ceną. */
export function linijkaBrutto(
  netto: number | string | null | undefined,
  waluta: string | null | undefined,
  okres?: OkresCeny
): string | null {
  const brutto = bruttoZNetto(netto, STAWKA_VAT_OPROGRAMOWANIA);
  if (brutto === null) return null;
  return `${kwotaPoPolsku(brutto)} ${symbolWaluty(waluta)} brutto${okres ? `/${okres}` : ''}`;
}
